var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopping1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M498 504L498 532",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 498.5,
    cy: 499.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M495.105 508C494.637 508 494.236 507.834 493.903 507.501C493.57 507.168 493.403 506.768 493.403 506.3C493.403 505.833 493.57 505.432 493.903 505.099C494.236 504.766 494.637 504.6 495.105 504.6C495.573 504.6 495.973 504.766 496.306 505.099C496.64 505.432 496.806 505.833 496.806 506.3C496.806 506.768 496.64 507.168 496.306 507.501C495.973 507.834 495.573 508 495.105 508ZM503.613 508C503.145 508 502.744 507.834 502.411 507.501C502.078 507.168 501.911 506.768 501.911 506.3C501.911 505.833 502.078 505.432 502.411 505.099C502.744 504.766 503.145 504.6 503.613 504.6C504.081 504.6 504.481 504.766 504.814 505.099C505.148 505.432 505.314 505.833 505.314 506.3C505.314 506.768 505.148 507.168 504.814 507.501C504.481 507.834 504.081 508 503.613 508ZM494.382 494.4L496.423 498.65H502.379L504.719 494.4H494.382ZM493.573 492.7H506.122C506.449 492.7 506.697 492.845 506.867 493.136C507.037 493.426 507.044 493.72 506.888 494.018L503.868 499.457C503.712 499.741 503.503 499.96 503.24 500.116C502.978 500.272 502.691 500.35 502.379 500.35H496.041L495.105 502.05H505.314V503.75H495.105C494.467 503.75 493.985 503.47 493.658 502.911C493.332 502.351 493.318 501.795 493.616 501.242L494.764 499.16L491.702 492.7H490V491H492.765L493.573 492.7Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping1);
export default __webpack_public_path__ + "static/media/shopping_1.9d6f8efd780ba599efac7fb8ed64153a.svg";
export { ForwardRef as ReactComponent };